import * as React from "react";
import { useMemo } from "react";
import TableFetchContext from "./TableFetchContext";
const TableFetchContextProvider = ({
  children = void 0,
  refetch,
  attributes,
  entityTableId,
  layoutVariant = void 0
}) => {
  const contextValue = useMemo(
    () => ({
      refetch,
      attributes,
      entityTableId,
      layoutVariant
    }),
    [refetch, attributes, entityTableId, layoutVariant]
  );
  return /* @__PURE__ */ React.createElement(TableFetchContext.Provider, { value: contextValue }, children);
};
export default TableFetchContextProvider;
